module.exports = __webpack_public_path__ + "img/go-build.db95da76.jpg";